import React from "react";
import Footer from "../Home/footer/Footer";
import Header from "../Home/header/Header";
import Section4 from "../Home/section4/Section4";
import Cover from "./Cover/Cover";
import PartnerLine from "./PartnerLineup/PartnerLine";
function Partner() {
  return (
    <div>
      <Header />
      <Cover />
      <PartnerLine />
      <Section4 />
      <Footer />
    </div>
  );
}

export default Partner;
